import React from "react";
import StockHistoricoUI from "./StockHistoricoUI";
import PageLoading from "../PageLoading";
import PageError from "../PageError";


class StockHistorico extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null,
        };
    }

    render() {
        const {isLoading, error} = this.state;
        if (isLoading) {
            return <PageLoading/>;
        }
        if (error) {
            return <PageError error={this.state.error}/>;
        }
        return (
            <div id="productosContainer">
                <StockHistoricoUI />
            </div>
        );
    }
}

export default StockHistorico;
